import { CLPUser } from "./clpuser.model";
import { SimpleResponse } from "./genericResponse.model";

export interface Task extends SimpleResponse {
  taskID: number;
  cLPUserID: number;
  cLPCompanyID: number;
  ownerID: number;
  taskDesc: string;
  category: number;
  priority: number;
  dtDue: string | Date;
  hours: number;
  cost: number;
  isPrivate: boolean;
  reminderCLP: boolean;
  reminderEmail: boolean;
  reminderTime: Date;
  reminderSent: boolean
  status: number;
  campaignID: number;
  campaignEventID: number;
  runID: number;
  dtCreated: Date;
  userLastFirst: string;
  ownerName: string;
  contactName: string;
  PriorityDisplay: string;
  TaskDescHTML: string;
  DisplayName: string;
  DisplayToolTip: string;
  DisplayURL: string;
  CategoryDisplay: string;
  CategoryURL: string;
  UserName: string;
  UserNameSort: string;
  DueDateDisplay: string;
  StatusDisplay: string;
  StatusImg: string;
  TaskDocURL: string;
  TaskDocURLEdit: string;
  ReminderDisplay: string;
    isShowAttached: boolean;
    contactFirstName: string;
    contactLastName: string;
    leadDesc: string;
}

export interface TaskListResponse {
  taskList: Task[];
  users: CLPUser[];
}

export interface TaskResponse extends SimpleResponse {
  task: Task;
}

export interface TaskDocListResponse extends SimpleResponse {
  taskDocs: any;
  taskID: number;
}

export interface LeadNextAction {
  leadId: number;
  taskId: number;
  taskDesc: string;
  dtDateDue: string;
  selectedUsedId: number;
}
